/*
 * Toff London customisation tester fixes v35
 * Staging theme only - updated 15 September 2026
 */
(function () {
  "use strict";

  var repeatDelay = 360;
  var repeatRate = 95;

  function setPreviewScale(dialog) {
    if (!dialog) return;
    var mobile = window.matchMedia("(max-width: 916px)").matches;
    if (!mobile) return;

    var compactHeight = Math.max(250, window.innerHeight * 0.5 - 48);
    var compactScale = Math.max(0.62, Math.min(1, (window.innerWidth - 20) / 412, compactHeight / 412));
    var fullScale = Math.max(0.7, Math.min(1.35, (window.innerWidth - 20) / 412, (window.innerHeight - 116) / 412));
    dialog.style.setProperty("--toff-preview-scale", String(compactScale));
    dialog.style.setProperty("--toff-full-preview-scale", String(fullScale));
  }

  function installFullscreenPreview(dialog) {
    if (!dialog || dialog.dataset.toffFullscreenReady === "true") return;
    var preview = dialog.querySelector(".w2shopify_dynamic_personalise_previewsets");
    var inner = preview && preview.querySelector(".w2shopify_dynamic_personalise_previewsets_inner");
    if (!preview || !inner) return;

    dialog.dataset.toffFullscreenReady = "true";
    var button = document.createElement("button");
    button.type = "button";
    button.className = "toff-preview-fullscreen-toggle";
    button.textContent = "Full screen";
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-label", "Open full screen preview");
    preview.appendChild(button);

    function closeFullscreen() {
      dialog.classList.remove("toff-preview-fullscreen");
      document.body.classList.remove("toff-preview-fullscreen-open");
      button.textContent = "Full screen";
      button.setAttribute("aria-expanded", "false");
      button.setAttribute("aria-label", "Open full screen preview");
    }

    button.addEventListener("click", function () {
      var opening = !dialog.classList.contains("toff-preview-fullscreen");
      dialog.classList.toggle("toff-preview-fullscreen", opening);
      document.body.classList.toggle("toff-preview-fullscreen-open", opening);
      button.textContent = opening ? "Close preview" : "Full screen";
      button.setAttribute("aria-expanded", opening ? "true" : "false");
      button.setAttribute("aria-label", opening ? "Close full screen preview" : "Open full screen preview");
      setPreviewScale(dialog);
    });

    preview.addEventListener("click", function (event) {
      if (!dialog.classList.contains("toff-preview-fullscreen")) return;
      var protectedContent = event.target.closest && event.target.closest(
        ".previewset, .switches, .w2shopify_ux_ready_front, .toff-preview-fullscreen-toggle"
      );
      if (!protectedContent) closeFullscreen();
    });

    dialog.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && dialog.classList.contains("toff-preview-fullscreen")) {
        event.stopPropagation();
        closeFullscreen();
        button.focus();
      }
    });

    setPreviewScale(dialog);
  }

  function variableForRange(range) {
    if (range.classList.contains("w2shopify_dynamic_personalise_possibility_inputs_input_offset_x")) return "offset_x";
    if (range.classList.contains("w2shopify_dynamic_personalise_possibility_inputs_input_offset_y")) return "offset_y";
    if (range.classList.contains("w2shopify_dynamic_personalise_possibility_inputs_input_scale")) return "scale";
    if (range.classList.contains("w2shopify_dynamic_personalise_possibility_inputs_input_rotation")) return "rotation";
    return null;
  }

  function installPrecisionButton(button) {
    if (!button || button.dataset.toffPressReady === "true") return;
    var row = button.parentNode;
    var range = row && row.querySelector("input");
    var possibility = button.closest("[data-possibilitypieceid]");
    var variable = range && variableForRange(range);
    var possibilityId = possibility && possibility.dataset.possibilitypieceid;
    if (!range || !variable || !possibilityId) return;

    button.dataset.toffPressReady = "true";
    button.removeAttribute("href");
    button.removeAttribute("onclick");
    button.setAttribute("role", "button");
    button.setAttribute("tabindex", "0");

    var isDown = button.classList.contains("w2shopify_dynamic_personalise_possibility_inputs_adjust_down");
    var amount = variable === "scale" ? (isDown ? -0.05 : 0.05) : (isDown ? -5 : 5);
    var delayTimer = null;
    var repeatTimer = null;
    var pressed = false;

    function applyAdjustment() {
      if (typeof window.w2shopify_dynamic_personalise_pi2_adjust === "function") {
        var current = parseFloat(range.value);
        var step = variable === "scale" ? 0.05 : 5;
        var next = current + amount;

        if ((variable === "scale" || variable === "rotation") && Number.isFinite(current)) {
          var scaled = current / step;
          next = (isDown ? Math.ceil(scaled - 1e-8) - 1 : Math.floor(scaled + 1e-8) + 1) * step;
          if (variable === "rotation") {
            if (next > 180) next = -180;
            if (next < -180) next = 180;
          }
          next = Math.round(next * 100) / 100;
          window.w2shopify_dynamic_personalise_pi2_adjust(possibilityId, variable, next - current);
        } else {
          window.w2shopify_dynamic_personalise_pi2_adjust(possibilityId, variable, amount);
        }
        range.dispatchEvent(new Event("input", { bubbles: true }));
        range.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    function stop() {
      pressed = false;
      window.clearTimeout(delayTimer);
      window.clearInterval(repeatTimer);
      delayTimer = null;
      repeatTimer = null;
      button.removeAttribute("data-pressed");
    }

    button.addEventListener("pointerdown", function (event) {
      if (event.button !== undefined && event.button !== 0) return;
      event.preventDefault();
      stop();
      pressed = true;
      button.setAttribute("data-pressed", "true");
      if (button.setPointerCapture && event.pointerId !== undefined) {
        try { button.setPointerCapture(event.pointerId); } catch (ignore) {}
      }
      applyAdjustment();
      delayTimer = window.setTimeout(function () {
        if (pressed) repeatTimer = window.setInterval(applyAdjustment, repeatRate);
      }, repeatDelay);
    }, { passive: false });

    button.addEventListener("pointerup", stop);
    button.addEventListener("pointercancel", stop);
    button.addEventListener("lostpointercapture", stop);
    button.addEventListener("contextmenu", function (event) { event.preventDefault(); });
    button.addEventListener("click", function (event) { event.preventDefault(); });
    button.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        applyAdjustment();
      }
    });
  }

  function installExactRotation(dialog) {
    var rotations = dialog.querySelectorAll(".w2shopify_dynamic_personalise_possibility_inputs_input_rotation");
    Array.prototype.forEach.call(rotations, function (input) {
      var current = parseFloat(input.value);
      if (current > 180) current -= 360;
      if (current < -180) current += 360;
      input.min = "-180";
      input.max = "180";
      input.step = "1";
      input.setAttribute("min", "-180");
      input.setAttribute("max", "180");
      input.setAttribute("step", "1");
      if (Number.isFinite(current)) input.value = String(current);
      input.setAttribute("aria-description", "Enter an exact angle. The adjacent buttons move in five degree steps.");
    });
  }

  function installPhotoValidationGuard(dialog) {
    var input = dialog.querySelector('.w2shopify_dynamic_personalise_possibility_inputs_input_file');
    if (!input) return;
    if (input.dataset.toffValidationGuard !== 'true') {
      input.dataset.toffValidationGuard = 'true';
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) return;
        if (['image/jpeg', 'image/png'].indexOf(file.type) !== -1 && file.size <= 20 * 1024 * 1024) return;
        window.setTimeout(function () {
          var status = dialog.querySelector('.w2shopify_ux_photo_status');
          if (typeof window.w2shopify_ux_set_photo_error !== 'function' || !status) return;
          var message = ['image/jpeg', 'image/png'].indexOf(file.type) === -1
            ? 'Please choose a JPEG or PNG image.'
            : 'This photo is larger than 20 MB. Please choose a smaller image.';
          window.w2shopify_ux_set_photo_error(input, status, message);
        }, 0);
      });
    }

    var status = dialog.querySelector('.w2shopify_ux_photo_status');
    if (status && status.dataset.toffErrorGuard !== 'true') {
      status.dataset.toffErrorGuard = 'true';
      new MutationObserver(function () {
        var message = status.dataset.toffErrorMessage;
        if (message && status.textContent !== message) {
          status.classList.add('is-error');
          status.textContent = message;
        }
      }).observe(status, { childList: true, characterData: true, subtree: true });
    }
  }

  function removeSkipAll(dialog) {
    var buttons = dialog.querySelectorAll(
      ".w2shopify_dynamic_personalise_form_submit_nothing, " +
      "[onmouseup*='w2shopify_dynamic_personalise_submit_nothing'], " +
      "[onclick*='w2shopify_dynamic_personalise_submit_nothing']"
    );
    Array.prototype.forEach.call(buttons, function (button) { button.remove(); });
  }

  function removeRedundantViewHelp(dialog) {
    var help = dialog.querySelector(".w2shopify_ux_view_help");
    if (help) help.remove();
  }

  function revealCustomButtonWhenReady() {
    var target = document.querySelector("#w2shopify_page_product_content");
    var ready = target && target.querySelector(".w2shopify_page_product_button");
    if (ready) document.documentElement.classList.remove("w2shopify-product-pending");
  }

  function install() {
    var dialog = document.getElementById("w2shopify_page_product_dialog");
    if (dialog) {
      installFullscreenPreview(dialog);
      installExactRotation(dialog);
      installPhotoValidationGuard(dialog);
      removeSkipAll(dialog);
      removeRedundantViewHelp(dialog);
      setPreviewScale(dialog);
      var buttons = dialog.querySelectorAll(".w2shopify_dynamic_personalise_possibility_inputs_adjust");
      Array.prototype.forEach.call(buttons, installPrecisionButton);
    }
    revealCustomButtonWhenReady();
  }

  var observer = new MutationObserver(install);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener("resize", function () {
    setPreviewScale(document.getElementById("w2shopify_page_product_dialog"));
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", install);
  } else {
    install();
  }
})();
